/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetContractCrewList,
  FleetContractCrewMember,
  FleetContractDetail,
  FleetContractInput,
  FleetContractItem,
  FleetContractItemInput,
  FleetContractProgress,
  FleetContractsList,
  FleetContractsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary List Fleet Contracts
 */
export const fleetContracts = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetContractsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetContractsList>(
      {url: `/fleets/${fleetSlug}/contracts`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetContractsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetContractsParams>,) => {
    return [
    'fleets',fleetSlug,'contracts', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetContractsQueryOptions = <TData = Awaited<ReturnType<typeof fleetContracts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetContractsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetContractsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetContracts>>> = ({ signal }) => fleetContracts(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetContracts>>, TError, TData>
}

export type FleetContractsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetContracts>>>
export type FleetContractsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Fleet Contracts
 */

export function useFleetContracts<TData = Awaited<ReturnType<typeof fleetContracts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetContractsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetContractsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleet Contract
 */
export const createFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractInput: MaybeRefOrGetter<FleetContractInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractInput = toValue(fleetContractInput);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetContractInput, signal
    },
      );
    }




export const getCreateFleetContractMutationKey = () => ['createFleetContract'] as const;

export const getCreateFleetContractMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContract>>, TError,CreateFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetContract>>, TError,CreateFleetContractMutationVariables, TContext> => {

const mutationKey = getCreateFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetContract>>, CreateFleetContractMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetContract(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetContract>>>
    export type CreateFleetContractMutationBody = FleetContractInput
    export type CreateFleetContractMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetContractMutationVariables = {fleetSlug: string;data: FleetContractInput}

    /**
 * @summary Create Fleet Contract
 */
export const useCreateFleetContract = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContract>>, TError,CreateFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetContract>>,
        TError,
        CreateFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary List Fleet Contract Crew
 */
export const fleetContractCrew = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);

      return axiosClient<FleetContractCrewList>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/crew`, method: 'GET', signal
    },
      );
    }




export const getFleetContractCrewQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'contracts',fleetContractSlug,'crew'
    ] as const;
    }


export const getFleetContractCrewQueryOptions = <TData = Awaited<ReturnType<typeof fleetContractCrew>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractCrew>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetContractCrewQueryKey(fleetSlug,fleetContractSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetContractCrew>>> = ({ signal }) => fleetContractCrew(fleetSlug,fleetContractSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetContractSlug) !== null && toValue(fleetContractSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetContractCrew>>, TError, TData>
}

export type FleetContractCrewQueryResult = NonNullable<Awaited<ReturnType<typeof fleetContractCrew>>>
export type FleetContractCrewQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Fleet Contract Crew
 */

export function useFleetContractCrew<TData = Awaited<ReturnType<typeof fleetContractCrew>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractCrew>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetContractCrewQueryOptions(fleetSlug,fleetContractSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Join Fleet Contract Crew
 */
export const joinFleetContractCrew = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);

      return axiosClient<FleetContractCrewMember>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/crew`, method: 'POST', signal
    },
      );
    }




export const getJoinFleetContractCrewMutationKey = () => ['joinFleetContractCrew'] as const;

export const getJoinFleetContractCrewMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinFleetContractCrew>>, TError,JoinFleetContractCrewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof joinFleetContractCrew>>, TError,JoinFleetContractCrewMutationVariables, TContext> => {

const mutationKey = getJoinFleetContractCrewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinFleetContractCrew>>, JoinFleetContractCrewMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug} = props ?? {};

          return  joinFleetContractCrew(fleetSlug,fleetContractSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinFleetContractCrewMutationResult = NonNullable<Awaited<ReturnType<typeof joinFleetContractCrew>>>

    export type JoinFleetContractCrewMutationError = ErrorType<ValidationError | StandardError>
    export type JoinFleetContractCrewMutationVariables = {fleetSlug: string;fleetContractSlug: string}

    /**
 * @summary Join Fleet Contract Crew
 */
export const useJoinFleetContractCrew = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinFleetContractCrew>>, TError,JoinFleetContractCrewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof joinFleetContractCrew>>,
        TError,
        JoinFleetContractCrewMutationVariables,
        TContext
      > => {
      return useMutation(getJoinFleetContractCrewMutationOptions(options), queryClient);
    }
    /**
 * @summary Leave Fleet Contract Crew
 */
export const leaveFleetContractCrew = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
id = toValue(id);

      return axiosClient<FleetContractCrewMember>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/crew/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getLeaveFleetContractCrewMutationKey = () => ['leaveFleetContractCrew'] as const;

export const getLeaveFleetContractCrewMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveFleetContractCrew>>, TError,LeaveFleetContractCrewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof leaveFleetContractCrew>>, TError,LeaveFleetContractCrewMutationVariables, TContext> => {

const mutationKey = getLeaveFleetContractCrewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveFleetContractCrew>>, LeaveFleetContractCrewMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,id} = props ?? {};

          return  leaveFleetContractCrew(fleetSlug,fleetContractSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveFleetContractCrewMutationResult = NonNullable<Awaited<ReturnType<typeof leaveFleetContractCrew>>>

    export type LeaveFleetContractCrewMutationError = ErrorType<ValidationError | StandardError>
    export type LeaveFleetContractCrewMutationVariables = {fleetSlug: string;fleetContractSlug: string;id: string}

    /**
 * @summary Leave Fleet Contract Crew
 */
export const useLeaveFleetContractCrew = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveFleetContractCrew>>, TError,LeaveFleetContractCrewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof leaveFleetContractCrew>>,
        TError,
        LeaveFleetContractCrewMutationVariables,
        TContext
      > => {
      return useMutation(getLeaveFleetContractCrewMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Fleet Contract Crew Request
 */
export const acceptFleetContractCrew = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
id = toValue(id);

      return axiosClient<FleetContractCrewMember>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/crew/${id}/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFleetContractCrewMutationKey = () => ['acceptFleetContractCrew'] as const;

export const getAcceptFleetContractCrewMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetContractCrew>>, TError,AcceptFleetContractCrewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetContractCrew>>, TError,AcceptFleetContractCrewMutationVariables, TContext> => {

const mutationKey = getAcceptFleetContractCrewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetContractCrew>>, AcceptFleetContractCrewMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,id} = props ?? {};

          return  acceptFleetContractCrew(fleetSlug,fleetContractSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetContractCrewMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetContractCrew>>>

    export type AcceptFleetContractCrewMutationError = ErrorType<ValidationError | StandardError>
    export type AcceptFleetContractCrewMutationVariables = {fleetSlug: string;fleetContractSlug: string;id: string}

    /**
 * @summary Accept Fleet Contract Crew Request
 */
export const useAcceptFleetContractCrew = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetContractCrew>>, TError,AcceptFleetContractCrewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetContractCrew>>,
        TError,
        AcceptFleetContractCrewMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptFleetContractCrewMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Fleet Contract Crew Request
 */
export const declineFleetContractCrew = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
id = toValue(id);

      return axiosClient<FleetContractCrewMember>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/crew/${id}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetContractCrewMutationKey = () => ['declineFleetContractCrew'] as const;

export const getDeclineFleetContractCrewMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetContractCrew>>, TError,DeclineFleetContractCrewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetContractCrew>>, TError,DeclineFleetContractCrewMutationVariables, TContext> => {

const mutationKey = getDeclineFleetContractCrewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetContractCrew>>, DeclineFleetContractCrewMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,id} = props ?? {};

          return  declineFleetContractCrew(fleetSlug,fleetContractSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetContractCrewMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetContractCrew>>>

    export type DeclineFleetContractCrewMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DeclineFleetContractCrewMutationVariables = {fleetSlug: string;fleetContractSlug: string;id: string}

    /**
 * @summary Decline Fleet Contract Crew Request
 */
export const useDeclineFleetContractCrew = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetContractCrew>>, TError,DeclineFleetContractCrewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetContractCrew>>,
        TError,
        DeclineFleetContractCrewMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineFleetContractCrewMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Fleet Contract Item
 */
export const createFleetContractItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    fleetContractItemInput: MaybeRefOrGetter<FleetContractItemInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
fleetContractItemInput = toValue(fleetContractItemInput);

      return axiosClient<FleetContractItem>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetContractItemInput, signal
    },
      );
    }




export const getCreateFleetContractItemMutationKey = () => ['createFleetContractItem'] as const;

export const getCreateFleetContractItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContractItem>>, TError,CreateFleetContractItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetContractItem>>, TError,CreateFleetContractItemMutationVariables, TContext> => {

const mutationKey = getCreateFleetContractItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetContractItem>>, CreateFleetContractItemMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,data} = props ?? {};

          return  createFleetContractItem(fleetSlug,fleetContractSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetContractItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetContractItem>>>
    export type CreateFleetContractItemMutationBody = FleetContractItemInput
    export type CreateFleetContractItemMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetContractItemMutationVariables = {fleetSlug: string;fleetContractSlug: string;data: FleetContractItemInput}

    /**
 * @summary Create Fleet Contract Item
 */
export const useCreateFleetContractItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetContractItem>>, TError,CreateFleetContractItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetContractItem>>,
        TError,
        CreateFleetContractItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetContractItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Fleet Contract Item
 */
export const updateFleetContractItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetContractItemInput: MaybeRefOrGetter<FleetContractItemInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
id = toValue(id);
fleetContractItemInput = toValue(fleetContractItemInput);

      return axiosClient<FleetContractItem>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/items/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetContractItemInput, signal
    },
      );
    }




export const getUpdateFleetContractItemMutationKey = () => ['updateFleetContractItem'] as const;

export const getUpdateFleetContractItemMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetContractItem>>, TError,UpdateFleetContractItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetContractItem>>, TError,UpdateFleetContractItemMutationVariables, TContext> => {

const mutationKey = getUpdateFleetContractItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetContractItem>>, UpdateFleetContractItemMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,id,data} = props ?? {};

          return  updateFleetContractItem(fleetSlug,fleetContractSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetContractItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetContractItem>>>
    export type UpdateFleetContractItemMutationBody = FleetContractItemInput
    export type UpdateFleetContractItemMutationError = ErrorType<ValidationError>
    export type UpdateFleetContractItemMutationVariables = {fleetSlug: string;fleetContractSlug: string;id: string;data: FleetContractItemInput}

    /**
 * @summary Update Fleet Contract Item
 */
export const useUpdateFleetContractItem = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetContractItem>>, TError,UpdateFleetContractItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetContractItem>>,
        TError,
        UpdateFleetContractItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetContractItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Fleet Contract Item
 */
export const destroyFleetContractItem = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetContractSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetContractSlug = toValue(fleetContractSlug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/contracts/${fleetContractSlug}/items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetContractItemMutationKey = () => ['destroyFleetContractItem'] as const;

export const getDestroyFleetContractItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContractItem>>, TError,DestroyFleetContractItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContractItem>>, TError,DestroyFleetContractItemMutationVariables, TContext> => {

const mutationKey = getDestroyFleetContractItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetContractItem>>, DestroyFleetContractItemMutationVariables> = (props) => {
          const {fleetSlug,fleetContractSlug,id} = props ?? {};

          return  destroyFleetContractItem(fleetSlug,fleetContractSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetContractItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetContractItem>>>

    export type DestroyFleetContractItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetContractItemMutationVariables = {fleetSlug: string;fleetContractSlug: string;id: string}

    /**
 * @summary Delete Fleet Contract Item
 */
export const useDestroyFleetContractItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContractItem>>, TError,DestroyFleetContractItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetContractItem>>,
        TError,
        DestroyFleetContractItemMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetContractItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Fleet Contract
 */
export const fleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetContractQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'contracts',slug
    ] as const;
    }


export const getFleetContractQueryOptions = <TData = Awaited<ReturnType<typeof fleetContract>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetContractQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetContract>>> = ({ signal }) => fleetContract(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetContract>>, TError, TData>
}

export type FleetContractQueryResult = NonNullable<Awaited<ReturnType<typeof fleetContract>>>
export type FleetContractQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Fleet Contract
 */

export function useFleetContract<TData = Awaited<ReturnType<typeof fleetContract>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContract>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetContractQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Contract
 */
export const updateFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetContractInput: MaybeRefOrGetter<FleetContractInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetContractInput = toValue(fleetContractInput);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetContractInput, signal
    },
      );
    }




export const getUpdateFleetContractMutationKey = () => ['updateFleetContract'] as const;

export const getUpdateFleetContractMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetContract>>, TError,UpdateFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetContract>>, TError,UpdateFleetContractMutationVariables, TContext> => {

const mutationKey = getUpdateFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetContract>>, UpdateFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetContract(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetContract>>>
    export type UpdateFleetContractMutationBody = FleetContractInput
    export type UpdateFleetContractMutationError = ErrorType<ValidationError>
    export type UpdateFleetContractMutationVariables = {fleetSlug: string;slug: string;data: FleetContractInput}

    /**
 * @summary Update Fleet Contract
 */
export const useUpdateFleetContract = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetContract>>, TError,UpdateFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetContract>>,
        TError,
        UpdateFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Fleet Contract
 */
export const destroyFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetContractMutationKey = () => ['destroyFleetContract'] as const;

export const getDestroyFleetContractMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContract>>, TError,DestroyFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContract>>, TError,DestroyFleetContractMutationVariables, TContext> => {

const mutationKey = getDestroyFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetContract>>, DestroyFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetContract>>>

    export type DestroyFleetContractMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Delete Fleet Contract
 */
export const useDestroyFleetContract = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetContract>>, TError,DestroyFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetContract>>,
        TError,
        DestroyFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel Fleet Contract
 */
export const cancelFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelFleetContractMutationKey = () => ['cancelFleetContract'] as const;

export const getCancelFleetContractMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetContract>>, TError,CancelFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelFleetContract>>, TError,CancelFleetContractMutationVariables, TContext> => {

const mutationKey = getCancelFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFleetContract>>, CancelFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  cancelFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFleetContract>>>

    export type CancelFleetContractMutationError = ErrorType<ValidationError>
    export type CancelFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Cancel Fleet Contract
 */
export const useCancelFleetContract = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetContract>>, TError,CancelFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelFleetContract>>,
        TError,
        CancelFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getCancelFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Claim Fleet Contract
 */
export const claimFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/claim`, method: 'PUT', signal
    },
      );
    }




export const getClaimFleetContractMutationKey = () => ['claimFleetContract'] as const;

export const getClaimFleetContractMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimFleetContract>>, TError,ClaimFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimFleetContract>>, TError,ClaimFleetContractMutationVariables, TContext> => {

const mutationKey = getClaimFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimFleetContract>>, ClaimFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  claimFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof claimFleetContract>>>

    export type ClaimFleetContractMutationError = ErrorType<ValidationError | StandardError>
    export type ClaimFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Claim Fleet Contract
 */
export const useClaimFleetContract = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimFleetContract>>, TError,ClaimFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof claimFleetContract>>,
        TError,
        ClaimFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getClaimFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Fulfil Fleet Contract
 */
export const fulfilFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/fulfil`, method: 'PUT', signal
    },
      );
    }




export const getFulfilFleetContractMutationKey = () => ['fulfilFleetContract'] as const;

export const getFulfilFleetContractMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fulfilFleetContract>>, TError,FulfilFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof fulfilFleetContract>>, TError,FulfilFleetContractMutationVariables, TContext> => {

const mutationKey = getFulfilFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fulfilFleetContract>>, FulfilFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  fulfilFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FulfilFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof fulfilFleetContract>>>

    export type FulfilFleetContractMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type FulfilFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Fulfil Fleet Contract
 */
export const useFulfilFleetContract = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fulfilFleetContract>>, TError,FulfilFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof fulfilFleetContract>>,
        TError,
        FulfilFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getFulfilFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Fleet Contract Progress
 */
export const fleetContractProgress = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractProgress>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/progress`, method: 'GET', signal
    },
      );
    }




export const getFleetContractProgressQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'contracts',slug,'progress'
    ] as const;
    }


export const getFleetContractProgressQueryOptions = <TData = Awaited<ReturnType<typeof fleetContractProgress>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetContractProgressQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetContractProgress>>> = ({ signal }) => fleetContractProgress(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetContractProgress>>, TError, TData>
}

export type FleetContractProgressQueryResult = NonNullable<Awaited<ReturnType<typeof fleetContractProgress>>>
export type FleetContractProgressQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Fleet Contract Progress
 */

export function useFleetContractProgress<TData = Awaited<ReturnType<typeof fleetContractProgress>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetContractProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetContractProgressQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Publish Fleet Contract
 */
export const publishFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/publish`, method: 'PUT', signal
    },
      );
    }




export const getPublishFleetContractMutationKey = () => ['publishFleetContract'] as const;

export const getPublishFleetContractMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetContract>>, TError,PublishFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishFleetContract>>, TError,PublishFleetContractMutationVariables, TContext> => {

const mutationKey = getPublishFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishFleetContract>>, PublishFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  publishFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof publishFleetContract>>>

    export type PublishFleetContractMutationError = ErrorType<ValidationError>
    export type PublishFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Publish Fleet Contract
 */
export const usePublishFleetContract = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetContract>>, TError,PublishFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof publishFleetContract>>,
        TError,
        PublishFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getPublishFleetContractMutationOptions(options), queryClient);
    }
    /**
 * @summary Release Fleet Contract
 */
export const releaseFleetContract = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetContractDetail>(
      {url: `/fleets/${fleetSlug}/contracts/${slug}/release`, method: 'PUT', signal
    },
      );
    }




export const getReleaseFleetContractMutationKey = () => ['releaseFleetContract'] as const;

export const getReleaseFleetContractMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseFleetContract>>, TError,ReleaseFleetContractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof releaseFleetContract>>, TError,ReleaseFleetContractMutationVariables, TContext> => {

const mutationKey = getReleaseFleetContractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof releaseFleetContract>>, ReleaseFleetContractMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  releaseFleetContract(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReleaseFleetContractMutationResult = NonNullable<Awaited<ReturnType<typeof releaseFleetContract>>>

    export type ReleaseFleetContractMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReleaseFleetContractMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Release Fleet Contract
 */
export const useReleaseFleetContract = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseFleetContract>>, TError,ReleaseFleetContractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof releaseFleetContract>>,
        TError,
        ReleaseFleetContractMutationVariables,
        TContext
      > => {
      return useMutation(getReleaseFleetContractMutationOptions(options), queryClient);
    }
